<template>
    <SideFormSection>
        <template #title> Group Scheduling Settings </template>
        <template #subtitle>
            Multi-seat booking rules for group meetings.
        </template>
        <template #rawContent>
            <Card
                title="Group Scheduling Settings"
                iconName="users"
            >
                <template #content>
                    <Alert
                        v-if="isDisabled"
                        title="NOTE:"
                        type="info"
                    >
                        Group scheduling settings are only available for group
                        meetings.
                    </Alert>
                    <Alert
                        v-else
                        title="NOTE:"
                        type="info"
                    >
                        Changing this setting is not going to affect existing
                        meetings.
                    </Alert>

                    <ApiForm
                        method="POST"
                        :url="
                            urlFactory.makeServiceUpdateGroupSchedulingSettingsUrl(
                                service.id,
                            )
                        "
                        ref="apiFormRef"
                    >
                        <ServiceGroupSchedulingSettingsForm
                            :service="service"
                            :errors="
                                apiFormRef?.response?.getErrors() ??
                                new ApiFormErrors({})
                            "
                            :isDisabled="isDisabled"
                        />
                    </ApiForm>
                </template>
                <template #actions>
                    <Button
                        @click="apiFormRef?.submit()"
                        :loading="apiFormRef?.loading.valueOf()"
                        iconName="save"
                        color="dark"
                        :disabled="isDisabled"
                    >
                        Save
                    </Button>
                </template>
            </Card>
        </template>
    </SideFormSection>
</template>

<script setup lang="ts">
    import { UrlFactory } from '@/Shared/Url/UrlFactory'
    import { ref, type PropType } from 'vue'
    import SideFormSection from '@/Shared/Component/SideFormSection.vue'
    import Card from '@/Shared/Component/Card.vue'
    import Service from '@/App/Service/Entity/Service'
    import Button from '@/Shared/Component/Button.vue'
    import type { ApiFormRefType } from '@/Shared/AutoGenerated/Types'
    import ApiFormErrors from '@/Shared/Component/Forms/ApiFormErrors'
    import ApiForm from '@/Shared/Component/Forms/ApiForm.vue'
    import Alert from '@/Shared/Component/Alert.vue'
    import ServiceGroupSchedulingSettingsForm from '@/App/Service/Component/Service/ServiceGroupSchedulingSettingsForm.vue'

    defineProps({
        service: {
            type: Object as PropType<Service>,
            required: true,
        },
        isDisabled: {
            type: Boolean,
            required: true,
        },
    })

    const apiFormRef = ref<ApiFormRefType>(null)
    const urlFactory = new UrlFactory()
</script>
